import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawGoogleClassIcon from "./RawGoogleClassIcon.svg.jsx";

const GoogleClassIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawGoogleClassIcon} {...props} />;
});

export default GoogleClassIcon;
